import React from 'react'
import { connect } from 'react-redux'
import { H1, H2 } from '@blueprintjs/core'

import { logout } from 'store/session'
import { fetchUser } from 'store/user'
import Header from 'components/Header'
import Footer from 'components/Footer'

import 'styles/About.css'
import icon3d from 'images/icon3d.png'
import science from 'images/science.png'
import oarc from 'images/oarc.png'
import felipe from 'images/team/felipe.png'
import matt from 'images/team/matt.png'
import lynn from 'images/team/lynn.png'
import rose from 'images/team/rose.png'
import jon from 'images/team/jon.png'
import leticia from 'images/team/leticia.png'
import justin from 'images/team/justin.png'
import richard from 'images/team/richard.png'
import aldo from 'images/team/aldo.png'
import christine from 'images/team/christine.png'
import marlene from 'images/team/marlene.png'
import michael from 'images/team/michael.png'
import nate from 'images/team/nate.png'
import lauren from 'images/team/lauren.png'
import cathy from 'images/team/cathy.png'
import keith from 'images/team/keith.png'
import wren from 'images/team/wren.png'
import anthony from 'images/team/anthony.png'

const Person = (props) => {
  let role
  let title

  if (props.role) {
    role = (
      <React.Fragment>
        <strong>{props.role}</strong>:
        <br />
      </React.Fragment>
    )
  }

  if (props.title) {
    title = (
      <React.Fragment>
        {props.title}
        <br />
      </React.Fragment>
    )
  }

  return (
    <div className="person">
      <img src={props.image} alt={props.name + ' picture'} />
      <p style={{ margin: '20px 0', textAlign: 'center' }}>
        {role}
        <strong>{props.name}</strong>
        <br />
        {title}
        (<a href={'mailto:' + props.email}>{props.email}</a>)
      </p>
    </div>
  )
}

class About extends React.Component {
  componentDidMount() {
    // Fetch user info if we don't have it yet
    if (this.props.session.jwt && !this.props.user) {
      this.props.fetchUser()
    }
  }

  render() {
    return (
      <React.Fragment>
        <Header
          user={this.props.user}
          path="/about"
          onLogout={this.props.logout}
        />

        <div className="eq-page">
          <div
            role="main"
            id="main-content"
            className="content aa"
            style={{ maxWidth: '80%', margin: 'auto' }}
          >
            <H1 style={{
              textAlign: 'center',
              fontSize: '38px',
              lineHeight: '44px',
              color: 'black',
            }}>
              <span className="blue">
                SPIRAL
              </span>:
              {' '}
              <span className="blue">S</span>upporting
              {' '}
              <span className="blue">P</span>rofessional
              {' '}
              <span className="blue">I</span>nquiry and
              {' '}
              <span className="blue">R</span>e‑
              <span className="blue">A</span>ligning
              {' '}
              <span className="blue">L</span>earning
              through a structured e‑portfolio system
            </H1>

            <p style={{ marginTop: '20px', textAlign: 'center', fontSize: '20px' }}>
              NSF Awards:
              {' '}
              <a
                href="https://www.nsf.gov/awardsearch/showAward?AWD_ID=2010505"
                style={{ fontSize: '20px' }}
              >
                2010505
              </a>
            </p>

            <div className="flex-wrapper">
              <img src={icon3d} alt="App icon" />
              <p style={{ marginLeft: '40px', fontSize: '16px' }}>
                The SPIRAL app is a digital portfolio tool that enables teachers
                to efficiently capture multiple representations of classroom
                practice via documents, images, and videos, and organize, share,
                and discuss evidence of student thinking reflected in these
                multimedia artifacts. Our project explores how use of the SPIRAL
                platform (iOS and Android apps, and Web Portal) can support
                teacher professional learning of high-quality science teaching,
                rooted in evidence of student thinking. We are working with
                professional learning communities composed of teachers from
                multiple grade levels (i.e. vertical PLCs) to examine student
                cross-grade learning trajectories aligned to the NGSS.
              </p>
            </div>

            <div style={{
              position: 'relative',
              width: '80%',
              margin: '40px auto',
              paddingBottom: 'calc(56.25% * 0.8)',
              height: 0,
            }}>
              <iframe
                src="https://www.youtube.com/embed/Pf5X-0OBDZs?si=cu4mRFtbWis2UtWm"
                title="SPIRAL: Supporting Professional Inquiry and Re-Aligning Learning through a structured e-portfolio"
                frameborder="0"
                allow="autoplay; encrypted-media"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }}
              >
              </iframe>
            </div>

            <a
              href="https://showcase.spiralproject.org"
              className="bp3-button bp3-minimal eq-button eq-button-inverted link-button"
              style={{ display: 'block', margin: 'auto', width: '300px' }}
            >
              LEARN MORE
            </a>
          </div>

          <H2 style={{
            margin: '80px 0 30px 0',
            fontSize: '28px',
            color: '#333333',
            textAlign: 'center',
          }}>
            Leadership
          </H2>

          <div className="people">
            <Person
              image={felipe}
              role="Principal Investigator"
              name="José Felipe Martínez"
              title="Associate Professor, School of Education and Information Studies, UCLA"
              email="jfmtz@ucla.edu"
            />
            <Person
              image={matt}
              role="Co-Principal Investigator"
              name="Matthew Kloser"
              title="Associate Professor &amp; Director, Notre Dame Center for STEM Education, University of Notre Dame"
              email="mkloser@nd.edu"
            />
            <Person
              image={lynn}
              role="Professional Development Lead"
              name="Lynn Kim-Joh"
              title="Director Educational Leadership Program, School of Education and Information Studies, UCLA"
              email="lkim@gseis.ucla.edu"
            />
            <Person
              image={rose}
              role="Software Development Lead"
              name="Rose Rocchio"
              title="Director, Mobile and Web Strategy, Office of Advanced Research Computing, UCLA"
              email="rrocchio@oarc.ucla.edu"
            />
          </div>

          <H2 style={{
            margin: '80px 0 30px 0',
            fontSize: '28px',
            color: '#333333',
            textAlign: 'center',
          }}>
            Professional Development Team
          </H2>

          <img
            src={science}
            alt="UCLA Science Project logo"
            style={{ display: 'inline-block', width: '100px', height: '100px', margin: '0 auto 30px auto' }}
          />

          <div className="people">
            <Person
              image={jon}
              name="Jon Kovach"
              email="kovach@gseis.ucla.edu"
            />
            <Person
              image={leticia}
              name="Leticia Perez"
              email="leticiaperezhuff@gmail.com"
            />
            <Person
              image={justin}
              name="Justin Betzelberger"
              email="betzelberger@g.ucla.edu"
            />
          </div>

          <div className="people">
            <Person
              image={richard}
              name="Richard Huynh"
              email="huynh@gseis.ucla.edu"
            />
            <Person
              image={aldo}
              name="Aldo Garcia"
              email="aldgarcia@gseis.ucla.edu"
            />
          </div>

          <H2 style={{
            margin: '80px 0 30px 0',
            fontSize: '28px',
            color: '#333333',
            textAlign: 'center',
          }}>
            Research Team
          </H2>

          <div className="people">
            <Person
              image={christine}
              name="Christine Ong"
              title="Senior Research Scientist, National Center for Research on Evaluation, Standards, and Student Testing, UCLA"
              email="ong@cresst.org"
            />
            <Person
              image={marlene}
              name="Marlene Saint Martin"
              title="PhD Student, School of Education and Information Studies, UCLA"
              email="marlenesaint@ucla.edu"
            />
            <Person
              image={michael}
              name="Michael Szopiak"
              title="Assistant Program Director, Center for STEM Education, University of Notre Dame"
              email="mszopiak@nd.edu"
            />
          </div>

          <H2 style={{
            margin: '80px 0 30px 0',
            fontSize: '28px',
            color: '#333333',
            textAlign: 'center',
          }}>
            Software Development Team
          </H2>

          <img
            src={oarc}
            alt="UCLA Advanced Research Computing logo"
            style={{ display: 'inline-block', height: '50px', margin: '0 auto 30px auto' }}
          />

          <div className="people">
            <Person
              image={nate}
              name="Nathan Jacobs"
              email="nsjacobs@ucla.edu"
            />
            <Person
              image={lauren}
              name="Lauren Cullen"
              email="lcullen@oarc.ucla.edu"
            />
            <Person
              image={cathy}
              name="Catherine Yanga"
              email="cyanga@oarc.ucla.edu"
            />
          </div>

          <div className="people">
            <Person
              image={keith}
              name="Keith Rozett"
              email="krozett@oarc.ucla.edu"
            />
            <Person
              image={wren}
              name="Wren Reynolds"
              email="wreynolds@oarc.ucla.edu"
            />
            <Person
              image={anthony}
              name="Anthony Doolan"
              email="adoolan@oarc.ucla.edu"
            />
          </div>

          <H2 style={{
            margin: '80px 0 30px 0',
            fontSize: '28px',
            color: '#333333',
            textAlign: 'center',
          }}>
            Advisory Board
          </H2>

          <p style={{ textAlign: 'center' }}>
            <strong>Alicia Alonzo</strong> (Michigan State University)<br />
            <strong>Hilda Borko</strong> (Stanford University)<br />
            <strong>Louis Gomez</strong> (University of California, Los Angeles)<br />
            <strong>Brian Stecher</strong> (The RAND Corporation)<br />
            <strong>Mark Windschitl</strong> (University of Washington)
          </p>

          <p style={{ textAlign: 'center', margin: '50px 0 50px 0' }}>
            For research inquiries and principal investigators contact:
            {' '}
            <a href="mailto:jfmtz@g.ucla.edu">
              jfmtz@g.ucla.edu
            </a> and
            {' '}
            <a href="mailto:mkloser@nd.edu">
              mkloser@nd.edu
            </a>
            <br />
            For technical support contact:
            {' '}
            <a href="mailto:mobilizelabs@oarc.ucla.edu">
              mobilizelabs@oarc.ucla.edu
            </a>
          </p>

          <Footer />
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  session: state.session,
  user: state.user,
})

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  fetchUser: () => dispatch(fetchUser()),
})

export default connect(mapStateToProps, mapDispatchToProps)(About)
